import { createActionTypes } from '@lifeomic/phc-web-toolkit/dist/redux/util/createActionTypes';

export default createActionTypes([
  'SIGNUP',
  'SET_LOGIN_PARAMS',
  'SET_CLIENT_ID',
  'SET_CLIENT_IDENTITY_PROVIDERS',
]);
